import { render, staticRenderFns } from "./KpiPayments.vue?vue&type=template&id=72378226&"
import script from "./KpiPayments.vue?vue&type=script&lang=js&"
export * from "./KpiPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports